/* Mayoristas landing — interacción (dot-grid, tilt 3D, count-up, scroll-reveal)
   Guardas de rendimiento: pausa canvas fuera de viewport, respeta prefers-reduced-motion. */
(function () {
  function init() {
    var root = document.querySelector('.wsl-page');
    if (!root) return;
    var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- Scroll reveal ---- */
    var reveals = root.querySelectorAll('.wsl-reveal');
    if (RM) {
      reveals.forEach(function (el) { el.classList.add('in'); });
    } else {
      var ro = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); ro.unobserve(e.target); } });
      }, { threshold: 0.12 });
      reveals.forEach(function (el, i) { el.style.transitionDelay = ((i % 6) * 70) + 'ms'; ro.observe(el); });
    }

    /* ---- Count up (al entrar a viewport) ---- */
    var stats = root.querySelectorAll('.wsl-stat__v[data-c]');
    var co = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        co.unobserve(e.target);
        var el = e.target, t = +el.dataset.c, suf = el.dataset.suf || '', plus = suf.indexOf('+') > -1, base = suf.replace('+', '');
        var n = 0, step = Math.max(1, Math.round(t / 26));
        var iv = setInterval(function () { n += step; if (n >= t) { n = t; clearInterval(iv); } el.textContent = (plus ? '+' : '') + n + base; }, 30);
      });
    }, { threshold: 0.5 });
    stats.forEach(function (el) { co.observe(el); });

    if (RM) return; /* sin canvas ni tilt en reduced-motion */

    /* ---- Tilt 3D (placas + perks) ---- */
    root.querySelectorAll('.wsl-tiltset > *').forEach(function (c) {
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'translateY(-6px) rotateY(' + (px * 6) + 'deg) rotateX(' + (-py * 6) + 'deg)';
      }, { passive: true });
      c.addEventListener('mouseleave', function () { c.style.transform = ''; });
    });

    /* ---- Dot-grid canvas (hero) con pausa fuera de viewport ---- */
    var cv = document.getElementById('wsl-dots');
    if (!cv) return;
    var cx = cv.getContext('2d'), hero = root.querySelector('.wsl-hero');
    var W, H, dots = [], mx = -999, my = -999, heroVis = true, raf = null;
    function build() {
      var r = hero.getBoundingClientRect();
      W = cv.width = r.width; H = cv.height = Math.max(r.height, 1);
      dots = [];
      var g = 34;
      for (var y = g / 2; y < H; y += g) for (var x = g / 2; x < W; x += g) dots.push({ x: x, y: y });
    }
    hero.addEventListener('mousemove', function (e) { var r = cv.getBoundingClientRect(); mx = e.clientX - r.left; my = e.clientY - r.top; }, { passive: true });
    hero.addEventListener('mouseleave', function () { mx = my = -999; });
    window.addEventListener('resize', build, { passive: true });
    new IntersectionObserver(function (es) { heroVis = es[0].isIntersecting; if (heroVis && !raf) loop(); }).observe(hero);
    function loop() {
      if (!heroVis) { raf = null; return; }
      cx.clearRect(0, 0, W, H);
      for (var i = 0; i < dots.length; i++) {
        var d = dots[i], dist = Math.hypot(d.x - mx, d.y - my), near = Math.max(0, 1 - dist / 150);
        cx.beginPath(); cx.arc(d.x, d.y, 1 + near * 3, 0, 7);
        cx.fillStyle = near > 0.04 ? 'rgba(244,130,31,' + (0.07 + near * 0.42) + ')' : 'rgba(140,132,120,.07)';
        cx.fill();
      }
      raf = requestAnimationFrame(loop);
    }
    build(); loop();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
